import React from "react";
import AdminFeatureTour, {
  markTourSeen,
  shouldAutoStartTour,
} from "../../components/AdminFeatureTour";

export const THEMEUPDATE_TOUR_STORAGE_KEY = "sl_admin_themeupdate_tour_seen_v1";

export const THEMEUPDATE_TOUR_STEPS = [
  {
    id: "welcome",
    target: "tour-gc-header",
    title: "Game Content",
    body: "This page holds the question/answer pairs used to build the puzzle.",
  },
  {
    id: "settings",
    target: "tour-gc-settings",
    title: "Question & answer pairs",
    body: "Add 2 to 12 question/answer pairs. Questions can be up to 80 characters, answers up to 15.",
  },
];

export default function ThemeUpdateFeatureTour({ open, onClose }) {
  return <AdminFeatureTour open={open} onClose={onClose} steps={THEMEUPDATE_TOUR_STEPS} />;
}

export function markThemeUpdateTourSeen() {
  markTourSeen(THEMEUPDATE_TOUR_STORAGE_KEY);
}

export function shouldAutoStartThemeUpdateTour() {
  return shouldAutoStartTour(THEMEUPDATE_TOUR_STORAGE_KEY);
}
